import { useState, useEffect, Suspense } from 'react';
import Header from './Header';
import BottomMenu from './BottomMenu';
import { useNavigate } from "react-router-dom";
import useMenu from '@/features/hooks/useMenu';
import useAuth from '@/features/hooks/useAuth';
import WaitingSpinner from '@/components/WaitingSpinner';
import Sidebar from './Sidebar';
import useNotificationApi from '@/services/api/useNotificationApi';

export default function Layout({ children }) {
    const navigate = useNavigate();
    const { CurrentComponent } = useMenu();
    const [showSidebar, setShowSidebar] = useState(false);
    const [isToggleOpen, setIsToggleOpen] = useState("hidden");
    const isShowBottomMenu = import.meta.env.VITE_APP_BOTTOM_MENU;
    const { isAuthenticated, isInitialized, user } = useAuth();
    const { GetNotificationList } = useNotificationApi();
    const [notifications, setNotifications] = useState([]);

    // Kimlik doğrulama ve yönlendirme işlemleri
    useEffect(() => {
        if (!isAuthenticated && isInitialized) {
            navigate(`/auth/login`);
        } else if (user?.changePassword) {
            navigate("/auth/changePassword");
        } else if (isAuthenticated) {
            // Kullanıcı doğrulandıktan sonra bildirimleri al
            fetchNotifications();
        }
    }, [isAuthenticated, isInitialized]);


    const fetchNotifications = async () => {
        try {
            const result = await GetNotificationList();
            setNotifications(result);
        } catch (error) {
            console.error("Error fetching notifications:", error);
        }
    };

    const mainToggleClass = isToggleOpen === "hidden" ? "" : "ml-[calc(15%+1rem)]";

    const renderProp = CurrentComponent ? <CurrentComponent>{children}</CurrentComponent> : children;

    if (!isAuthenticated) return <WaitingSpinner />;

    return (
        <>
            <header className='fixed top-0 left-0 w-full z-header font-sans'>
                <Header 
                    showSidebarHandler={setShowSidebar} 
                    showDateSelection={true}  
                    mainToggleClass={mainToggleClass} 
                    notifications={notifications} // Bildirimleri Header'a gönderiyoruz
                />
            </header>
            <main className={`font-sans pt-[60px] pb-[50px] ${mainToggleClass}`}>
                <Suspense fallback={<div>Loading...</div>}>
                    <Sidebar sidebarData={{ showSidebar, showSidebarHandler: setShowSidebar, isToggleOpen, setIsToggleOpen }} />
                </Suspense>
                <div className="flex-grow overflow-y-auto">
                    {renderProp}
                </div>
            </main>
            {isShowBottomMenu === "true" && user?.authenticationProviderType !== "Unknown" && (
                <footer className="fixed bottom-0 left-0 w-full z-bottomMenu p-0 font-sans">
                    <BottomMenu />
                </footer>
            )}
        </>
    );
}
